import React from "react";
import "../../styles/utilities.css";
import {Outlet} from "react-router-dom";


const NoneAuthenticatedLayout: React.FC = () => {
  return (
    <div className="none-authenticated-layout-wrapper">
      <Outlet/>
    </div>
  );
};

export default NoneAuthenticatedLayout;